import React from "react";
import { Link } from "react-router-dom";
import { LegalShell, Section } from "../components/LegalShell";

export default function RefundPolicy() {
    return (
        <LegalShell
            eyebrow="Legal"
            title="Refund Policy"
            subtitle="Overview of how refunds and the EU right of withdrawal work for EuroLaw Hub subscriptions."
            lastUpdated="16 July 2026"
        >
            <div data-testid="refund-policy-page">
                <Section title="1. Who processes your payment">
                    <p>
                        Subscriptions are sold and processed by <strong>our merchant-of-record
                        payment provider</strong>, which handles the payment transaction, VAT/GST
                        and invoicing, and issues your receipt. Refunds are executed through the
                        same channel and returned to your original payment method.
                    </p>
                </Section>

                <Section title="2. EU 14-day right of withdrawal">
                    <p>
                        If you subscribe as a <strong>consumer</strong> in the EU/EEA, you have a
                        14-day right of withdrawal under the Consumer Rights Directive (2011/83/EU).
                        Because EuroLaw Hub is a digital service delivered immediately, at checkout
                        you expressly consent to immediate performance and acknowledge that, once
                        you start using the paid service within the 14-day period, you lose the
                        right of withdrawal for the portion already performed. If you withdraw
                        within 14 days without having used the paid service, you receive a full
                        refund. If you have partially used it, any refund is reduced
                        proportionately to the service already provided.
                    </p>
                    <p>
                        Business customers (purchases made for professional purposes) are not
                        covered by the consumer withdrawal right; the sections below still apply.
                    </p>
                </Section>

                <Section title="3. Billing errors and duplicate charges">
                    <p>
                        Charges resulting from a billing error, duplicate payment, or a technical
                        fault on our side are refunded in full, no questions asked. Beyond that,
                        we handle requests pragmatically and may issue pro-rated or discretionary
                        refunds, for example where the service was materially unavailable during
                        your billing period.
                    </p>
                </Section>

                <Section title="4. How to request a refund">
                    <p>
                        Email <a href="mailto:altay@eurolawhub.com" className="underline hover:text-[#C9A84C]">altay@eurolawhub.com</a>{" "}
                        from your account email with your invoice or order reference and a short
                        description. We acknowledge requests within 2 business days and decide
                        within 14 days. Approved refunds are initiated immediately; depending on
                        your bank or card issuer, the amount typically arrives within
                        5-10 business days.
                    </p>
                </Section>

                <Section title="5. Cancellations are not refunds">
                    <p>
                        You can cancel any time from{" "}
                        <Link to="/app/billing/portal" className="underline hover:text-[#C9A84C]">Billing → Manage subscription</Link>.
                        Cancellation stops future renewals; you keep access until the end of the
                        paid period. The free trial requires no payment, so nothing is charged or
                        refunded when a trial ends.
                    </p>
                    <p>
                        This page summarises our practice and does not limit any mandatory rights
                        you have under applicable consumer law. See also our{" "}
                        <Link to="/legal" className="underline hover:text-[#C9A84C]">Terms of Service</Link>.
                    </p>
                </Section>
            </div>
        </LegalShell>
    );
}
